import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";
import { DashboardComponentPropsBase } from "components/pages/dashboard/components/interfaces";

export enum CellType {
  STRING = "string",
  NUMBER = "number",
  DATASET = "dataset",
  UNIT = "unit",
  URL = "url",
  SEPARATOR = "separator",
}

export enum ColorKey {
  COLOR = "color",
  BG_COLOR = "bgColor",
  MIN_TEXT_COLOR = "minTextColor",
  MAX_TEXT_COLOR = "maxTextColor",
  MIN_BG_COLOR = "minBgColor",
  MAX_BG_COLOR = "maxBgColor",
}

export enum RemoveContentType {
  COLUMN = "column",
  ROW = "row",
}

export interface CellValuesEditorProps {
  currentConfig: IUniversalDatasetTableConfig;
  setCurrentConfig: (config: IUniversalDatasetTableConfig) => void;
}

export interface RowData {
  columns: IUniversalDatasetTableColumn[];
  rowIndex: number;
  isSeparator?: boolean;
}

export interface IUniversalDatasetTableConfig extends DashboardComponentPropsBase {
  rows: IUniversalDatasetTableRow[];
  columnsOptions: ColumnOptions[];
  showColumnHeaders?: boolean;
  compactMode?: boolean;
  hideHeader?: boolean;
  updateFrequency?: number | null;
  maxAge?: number;
}

export interface EditColumnProps {
  selectedColumnOptions: ColumnOptions;
  setSelectedColumnOptions: (columnOptions: ColumnOptions) => void;
  isEditColumnDialogVisible: boolean;
  setEditColumnDialogVisible: (isEditingColumnDialogVisible: boolean) => void;
  removeColumn: () => void;
}

export interface ColumnOptions {
  id: string;
  title: string;
  columnHeaderVisibility: boolean;
  columnVisibility: boolean;
}

export interface EditBasicCellDialogProps {
  isEditBasicCellDialogVisible: boolean;
  setIsEditBasicCellDialogVisible: (isEditBasicCellDialogVisible: boolean) => void;
  selectedCell: ICellConfig;
  updateSelectedCell: (selectedCell: ICellConfig) => void;
}

export enum MinMaxValueType {
  MIN = "min",
  MAX = "max",
}

export interface IEditDatasetCellDialogProps {
  isEditDatasetCellDialogVisible: boolean;
  setIsEditDatasetCellDialogVisible: (value: boolean) => void;
  selectedDatasetCell: ICellConfig;
  updateSelectedDatasetCell: (selectedDatasetCell: ICellConfig) => void;
}

export interface UniversalDatasetEditorDialogProps {
  config: IUniversalDatasetTableConfig;
  onConfigChange: (config: IUniversalDatasetTableConfig) => void;
  setDialogVisible: (visible: boolean) => void;
  isDialogVisible: boolean;
}

export interface DatasetButtonProps {
  dataset: DatasetDataInfoResponse;
  columnIndex: number;
  rowData: IUniversalDatasetTableRow;
  compactMode?: boolean;
  maxAge?: number;
  isExpired?: boolean;
}

export type DatasetButtonWrapperProps = {
  datasetId?: string;
  columnIndex: number;
  rowData: IUniversalDatasetTableRow;
  dataset: DatasetDataInfoResponse;
  data?: InstantDoubleValue | null;
  time: Date;
  compactMode?: boolean;
  maxAge?: number;
};

export type DatasetButtonComponentProps = {
  id?: string;
  columnIndex: number;
  rowData: IUniversalDatasetTableRow;
  dataset: DatasetDataInfoResponse;
  data?: InstantDoubleValue | null;
  time: Date;
  compactMode?: boolean;
  isExpired?: boolean;
};

export interface IUniversalDatasetTableRow {
  uuid?: string;
  columns: IUniversalDatasetTableColumn[];
  isSeparator?: boolean;
}

export interface IUniversalDatasetTableColumn {
  cell: ICellConfig;
}

export interface ICellConfig {
  type: CellType;
  value?: string | number | null;
  displayDatasetValueTime?: boolean;
  setMinMaxColors?: boolean;
  minMaxColor?: {
    minTextColor?: string;
    maxTextColor?: string;
    minBgColor?: string;
    maxBgColor?: string;
  };
  minMaxValue?: {
    minValue?: number;
    maxValue?: number;
  };
  timePattern?: string;
  highlightColor?: {
    color?: string;
    bgColor?: string;
  };
}

export interface UniversalDatasetTableRowProps {
  recentData?: DatasetDataInfoResponse[];
  rowData: IUniversalDatasetTableRow;
  columnsOptions: ColumnOptions[];
  compactMode?: boolean;
  maxAge?: number;
  isSelected?: boolean;
  rowIndex: number;
  onClick?: (index: number) => void;
}
